import React from "react";
import { altColor } from "../../utils/constants";

export default function IconVideos({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 432">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <path
            d="M462,0H301.13a10,10,0,0,0,0,20H462a30,30,0,0,1,30,30V292H20V50A30,30,0,0,1,50,20H301a10,10,0,0,0,0-20H50A50.06,50.06,0,0,0,0,50V382a50.06,50.06,0,0,0,50,50H462a50.06,50.06,0,0,0,50-50V50A50.06,50.06,0,0,0,462,0Zm0,412H50a30,30,0,0,1-30-30V312H492v70A30,30,0,0,1,462,412Z"
            fill={color}
          />
          <path
            d="M99.93,332a30,30,0,1,0,30,30A30,30,0,0,0,99.93,332Zm0,40a10,10,0,1,1,10-10A10,10,0,0,1,99.93,372Z"
            fill={color}
          />
          <path d="M432.08,352H183a10,10,0,0,0,0,20H432.08a10,10,0,0,0,0-20Z" fill={color} />
          <path
            d="M204.88,125.68v60.64A28.46,28.46,0,0,0,247.67,211l52.52-30.32a28.52,28.52,0,0,0,0-49.4L247.67,101a28.53,28.53,0,0,0-42.79,24.7Zm20,0a8.37,8.37,0,0,1,4.26-7.38,8.79,8.79,0,0,1,4.31-1.17,8.35,8.35,0,0,1,4.22,1.17l52.52,30.32a8.52,8.52,0,0,1,0,14.76L237.67,193.7a8.52,8.52,0,0,1-12.78-7.38V125.68Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
}
